export default {
  methods: {
    // Libellé de champ paramétré en back-office, replié sur le libellé livré si la ressource est absente ou vide
    libelleRessource(code, libelleParDefaut) {
      const texte = this.$store.getters["ParamFormulaireDeprecated/ressources"]?.get(code)?.texte
      if (!texte) {
        return libelleParDefaut
      }
      // Les ressources sont saisies en HTML : seul le texte peut alimenter un libellé de champ
      const conteneur = document.createElement("div")
      conteneur.innerHTML = texte
      return conteneur.textContent.trim() || libelleParDefaut
    },
  },
}
